import { createSlice } from "@reduxjs/toolkit";
import { fetchPurchaseReturnRecord } from "./PurchaseReturnRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE", // later could be dynamic
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const purchaseReturnRecordSlice = createSlice({
  name: "purchaseReturnRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseReturnRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPurchaseReturnRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPurchaseReturnRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = purchaseReturnRecordSlice.actions;
export default purchaseReturnRecordSlice.reducer;
